export default "__VITE_ASSET__BAGIxj7V__"